export const SITE_NAME = 'Family Tree Maker';
export const SITE_TAGLINE = 'Genealogy Support & Guidance';
export const SITE_DOMAIN = 'familytreemakerheldesk.online';
export const SITE_URL = 'https://www.familytreemakerheldesk.online';

export const SUPPORT_EMAIL = 'support@familytreemakerheldesk.online';
export const SUPPORT_PHONE = '+1-844-499-3050';
export const SUPPORT_PHONE_TEL = '+18444993050';
export const SUPPORT_HOURS = 'Available 24/7';

/** Lead Desk — form posts here */
export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_d8497da3213262fbb5611cfc4dc8ebaf187249297ff83298';

/** Legal operator — Nodex Global LLC */
export const COMPANY_NAME = 'Nodex Global LLC';
export const COMPANY_EMAIL = 'info@nodexgloballlc.com';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS = `${ADDRESS_LINE1} ${ADDRESS_LINE2}`;

export const POLICY_UPDATED = 'August 29, 2026';

export const FOOTER_DISCLAIMER =
  'We are an independent third-party support resource and are not affiliated with, endorsed by, or sponsored by Family Tree Maker or its trademark owners. Product names are used for identification only.';
